import React from 'react';
import { Provider } from 'react-redux'
import { store, persistor } from './store'
import Router from './router/'
import { PersistGate } from 'redux-persist/integration/react'
import './scss/index.scss'
import './App.scss'

const App: React.SFC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        { Router }
      </PersistGate>
    </Provider>
  );
}

export default App;